import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { DataService } from "../../../_services/data.service";
import { AuthenticationService } from "../../../_services/authentication.service";

import { EventStatus } from "../event-page-models/event-status";
import { eventPageUtils } from "../utils/event-page-utils";
import { getEnumNumbers } from "../../../_helpers/enum-utils";
import { ChildEvent } from "../event-page-models/child-event";
import { SelectMenuOption } from "../../../form/select-menu/select-menu.component";
import { trimTextByWord } from "../utils/trimTextByWord";

@Component({
  selector: "parent-events-row-details-child-events-row",
  templateUrl: "./parent-events-row-details-child-events-row.component.html",
  styleUrls: [
    "../parent-events-row/parent-events-row.component.scss",
    "./parent-events-row-details-child-events-row.component.scss",
  ],
})
export class ParentEventsRowDetailsChildEventsRowComponent
  implements OnInit, OnDestroy
{
  @Input() public childEvent: ChildEvent;
  public eventStatusMenuOptions: SelectMenuOption[] = [
    {
      icon: "",
      key: "dropdown",
      text: "פתוח",
      customValue: "",
    },
    {
      icon: "",
      key: "dropdown",
      text: "סגור",
      customValue: "",
    },
  ];
  public childEventStatus: SelectMenuOption = this.eventStatusMenuOptions[0];
  // tslint:disable-next-line:no-empty
  public changeStatusOptions =
    ParentEventsRowDetailsChildEventsRowComponent.buildStatusOptions();
  // tslint:disable-next-line:no-empty
  public openToExtendedText: any = "";

  constructor(
    private dataService: DataService,
    private authenticationService: AuthenticationService
  ) {}

  public static buildStatusOptions() {
    return getEnumNumbers(EventStatus).map((n) => ({
      text: eventPageUtils.eventStatusToText(n),
      value: n,
    }));
  }

  ngOnInit(): void {
    this.childEventStatus =
      this.childEvent.eventStatus === EventStatus.Open
        ? this.eventStatusMenuOptions[0]
        : this.eventStatusMenuOptions[1];
  }

  ngOnDestroy(): void {}

  public formatDate(date: Date) {
    return `${date.getDate()}.${date.getMonth() + 1}.${
      date.getFullYear() - 2000
    }`;
  }

  changeStatus($event: Event) {
    $event.stopPropagation();
    $event.stopPropagation();
  }

  public rowClicked($event): void {}
  public trimText(text: string, maxlength = 14) {
    return trimTextByWord(text, maxlength);
  }

  public clickedChangeEventStatus($event: SelectMenuOption) {}
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/parent-events-row-details-child-events-row/parent-events-row-details-child-events-row.component.ts